import { Utilities, CHECKOUT_DEFAULT_VIEWS } from 'core/domains';
import type { Checkout } from 'core/domains';

/**
 * Presentation logic: Sets true if there's no async request running,
 * payment detail request status is success and
 * isReady is true when cart reached minimum value.
 */
export function canSubmit(draft: Checkout) {
  const isRunning = isCheckoutRunning(draft);
  const { isReady, paymentDetail } = draft;

  return !isRunning && isReady && paymentDetail.status === Utilities.STATUS.SUCCESS;
}

/**
 * Keep the isRunning state based on async flow race conditions.
 */
export function isCheckoutRunning(draft: Checkout) {
  return [draft.paymentDetail, draft.paymentMethods, draft.order].some(
    ({ status }) => status === Utilities.STATUS.RUNNING,
  );
}

/**
 * Updates steps if is completed
 */
export function updateStepCompleted(state: Checkout, step: Checkout['step']) {
  const stepKeys = Object.keys(CHECKOUT_DEFAULT_VIEWS);
  const currentStepIndex = stepKeys.indexOf(step);

  stepKeys.forEach((currentStep, index) => {
    if (index < currentStepIndex) {
      state.views[currentStep as Checkout['step']].completed = true;
    }
  });
}
